<template>
  <div class="xy-center flex-y" style="width:100%;height:100%">
    <img src="https://oss.yf-gz.cn/file/1735553285863_88ff74e13bb7d44b5e055205c03add69.png" alt="" style="width:196px;height:214px">
    <div class="empty-text">{{ title }}</div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
  },
}
</script>
<style lang="less" scoped>
.empty-text {
  height: 16px;
  font-size: 16px;
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 400;
  color: #666666;
  line-height: 16px;
  // margin-top: -38px;
}
.flex-y {
  flex-direction: column;
}

</style>


// WEBPACK FOOTER //
// src/zzcbpmDashboard/common/black-empty.vue